module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.c19c88e.woff2";